import { render, staticRenderFns } from "./CreateAccountAsInvited.vue?vue&type=template&id=60586e5a"
import script from "./CreateAccountAsInvited.vue?vue&type=script&lang=js"
export * from "./CreateAccountAsInvited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports